module.exports = __webpack_public_path__ + "img/20110201_06.5636e471.jpg";